import { LexicalEditor, REDO_COMMAND } from "lexical";
import React, { useCallback } from "react";
import { RedoIcon } from "../../../../assets/icons/SvgIcons";

interface RedoProps {
  canRedo: boolean;
  editor: LexicalEditor;
  isDropdown: boolean;
  readOnly?: boolean;
}

const Redo: React.FC<RedoProps> = ({
  canRedo,
  editor,
  isDropdown,
  readOnly,
}) => {
  const handleRedo = useCallback(() => {
    editor.dispatchCommand(REDO_COMMAND, undefined);
  }, [editor]);

  return (
    <button
      type="button"
      disabled={!canRedo || readOnly}
      onClick={handleRedo}
      className={`lexical-toolbarItem ${
        isDropdown ? "lexical-dropdownItem" : ""
      }`}
      aria-label="Redo"
      aria-disabled={!canRedo}
    >
      <div className="lexical-shortcutWrapper">
        <RedoIcon />
        {isDropdown && (
          <span
            className="lexical-shortcutText"
            style={{ marginRight: "41px" }}
          >
            Redo
          </span>
        )}
      </div>
      {isDropdown && <span className="lexical-shortcut">Ctrl+Y</span>}
    </button>
  );
};

export default Redo;
